import React from 'react'
import { connect } from 'react-redux'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer
} from 'react-google-maps'
import { MarkerWithLabel } from 'react-google-maps/lib/components/addons/MarkerWithLabel'
import { compose, withProps, lifecycle } from 'recompose'

const MAP_STYLES = [
  {
    featureType: 'all',
    elementType: 'all',
    stylers: [{ hue: '#DDDFEB' }]
  },
  {
    featureType: 'road',
    stylers: [{ color: '#DDDFEB' }]
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'administrative.province',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'administrative.locality',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#B0B4D1',
        weight: '20px'
      }
    ]
  },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#eee'
      }
    ]
  },
  {
    featureType: 'administrative.country',
    elementType: 'labels.text.stroke',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'landscape.natural.landcover',
    stylers: [{ visibility: 'off' }]
  },
  {
    featureType: 'water',
    stylers: [{ color: '#DDDFEB' }]
  }
]

const MARKERS = [
  {
    position: { lat: 37.54, lng: -122.301 },
    labelAnchorPoints: [45, 45],
    city: <span>San&nbsp;Francisco</span>
  },
  {
    position: { lat: 34.056, lng: -118.239 },
    labelAnchorPoints: [45, -10],
    city: <span>Los&nbsp;Angeles</span>
  },
  {
    position: { lat: 34.34, lng: -112.1 },
    labelAnchorPoints: [35, 40],
    city: <span>Arcosanti</span>
  },
  {
    position: { lat: 30.2, lng: -97.742 },
    labelAnchorPoints: [45, 45],
    city: <span>Austin</span>
  },
  {
    position: { lat: 29.93, lng: -90.06 },
    labelAnchorPoints: [-10, 20],
    city: <span>New&nbsp;Orleans</span>
  },
  {
    position: { lat: 40.74, lng: -73.991 },
    labelAnchorPoints: [45, -10],
    city: <span>New&nbsp;York</span>
  }
]
/* eslint-disable no-undef */
const AirstreamMap = compose(
  withProps({
    googleMapURL:
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBqnEjA264KsaM7mBjbYfo-0wGFRJ707j4&v=3.exp&libraries=geometry,drawing,places',
    loadingElement: <div style={{ height: '100%' }} />,
    containerElement: <div style={{ height: '100%' }} />,
    mapElement: (
      <div
        style={{
          left: 0,
          top: 0,
          height: '100%',
          width: '100%',
          position: 'absolute'
        }}
      />
    )
  }),
  withScriptjs,
  withGoogleMap,
  lifecycle({
    componentDidMount () {
      const DirectionsService = new google.maps.DirectionsService()

      DirectionsService.route(
        {
          origin: new google.maps.LatLng(37.54, -122.301),
          destination: new google.maps.LatLng(40.74, -73.991),
          waypoints: [
            { location: 'Los Angeles' },
            { location: new google.maps.LatLng(34.34, -112.1) },
            { location: 'Austin' },
            { location: new google.maps.LatLng(29.93, -90.06) }
          ],
          travelMode: google.maps.TravelMode.DRIVING
        },
        (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            this.setState({
              directions: result
            })
          } else {
            console.error(`error fetching directions ${result}`)
          }
        }
      )
    }
  })
)(props => {
  const { greaterThanSm } = props
  const MARKER_ICON = {
    path: google.maps.SymbolPath.CIRCLE,
    scale: greaterThanSm ? 5 : 3,
    fillColor: '#ffffff',
    fillOpacity: 1,
    strokeColor: '#534c73',
    strokeWeight: greaterThanSm ? 3 : 2
  }

  // LATER: see if possible to set two polylines
  const directionsRendererOptions = {
    suppressMarkers: true,
    polylineOptions: {
      strokeColor: '#3948FF',
      strokeWeight: greaterThanSm ? 4 : 2,
      geodesic: true
    },
    preserveViewport: true
  }

  return (
    <GoogleMap
      defaultZoom={greaterThanSm ? 4 : 3}
      defaultCenter={{ lat: 35.397, lng: -95.644 }}
      defaultOptions={{ styles: MAP_STYLES }}
    >
      {MARKERS.map(({ position, labelAnchorPoints, city }, idx) => (
        <MarkerWithLabel
          key={idx}
          position={position}
          labelAnchor={new google.maps.Point(...labelAnchorPoints)}
          labelClass='airstream-map__marker-label'
          icon={MARKER_ICON}
        >
          <div className='airstream-map__marker-label__inner bg-white small xs-hide'>
            {city}
          </div>
        </MarkerWithLabel>
      ))}
      {props.directions && (
        <DirectionsRenderer
          directions={props.directions}
          defaultOptions={directionsRendererOptions}
        />
      )}
    </GoogleMap>
  )
})
/* eslint-enable */

function mapStateToProps ({ browser }) {
  return {
    greaterThanSm: browser.greaterThan.sm
  }
}

export default connect(mapStateToProps)(AirstreamMap)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/AirstreamMap.js